import { put } from "../api";

export const updateForm = async (data, documentList, user) => {
  try {
    const url = `api/form/${documentList?._id}`;
    const res = await put(url, data, user?.token);
  } catch (e) {}
};
